import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../../../services/account/account.service';
import { CustomerService } from '../../../../../../../../../services/customer/customer.service';
import { openClimberAppInNewTabAsCustomer } from '../../../../../../../../../utils-models';
import { OrganizationConfigService } from '../../../../../../../../../services/organization-config/organization-config.service';
import { Customer } from '../../../../../../../../../models/customer';
import { VoucherPack, VoucherPackStatus } from '../../../../../../../../../models/voucher-pack';
import { VoucherPackService } from '../../../../../../../../../services/voucher-pack/voucher-pack.service';

@Component({
  selector: 'app-purchase-voucher-pack-modal',
  templateUrl: './purchase-voucher-pack-modal.component.html',
  styleUrls: ['./purchase-voucher-pack-modal.component.css']
})
export class PurchaseVoucherPackModalComponent implements OnInit {

  @Input() customer: Customer;

  public voucherPackId: number = null;

  public voucherPackList: VoucherPack[];

  public loadingVoucherPacks = true;
  public loadingSubmit = false;

  public serverError: number = null;

  public errors: any = {};
  public errorMessage = '';

  public VoucherPackStatus = VoucherPackStatus;

  constructor(
    private accountService: AccountService,
    private voucherPackService: VoucherPackService,
    private customerService: CustomerService,
    private orgService: OrganizationConfigService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    this.loadVoucherPacks();
  }

  public handleSave() {
    this.loadingSubmit = true;
    this.errors = {};
    this.errorMessage = '';

    this.customerService
      .getCustomerClimberAppToken(this.customer.id)
      .then(token => {
        const baseUrl = this.orgService.getOrganizationConfig().climber_app_base_url;
        const nextUrl = baseUrl + 'voucher-pack/purchase-init/' + this.voucherPackId.toString() + '/';
        openClimberAppInNewTabAsCustomer(
          token,
          this.customer.id,
          baseUrl,
          nextUrl
        );
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to purchase voucher packs for this customer.';
        } else if (reason.status === 400) {
          this.errorMessage = 'Please correct the errors above and try again.';
          this.errors = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  private loadVoucherPacks() {
    this.loadingVoucherPacks = true;

    this.voucherPackService
      .getVoucherPacks(
        1,
        3000,
        {status: VoucherPackStatus.active}
      )
      .then(response => {
        this.voucherPackList = response.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingVoucherPacks = false; });
  }

}
